(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3613,5384,3129,4521,1651],{

/***/ 81666:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ArrowDown_ArrowDown; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ../../packages/icons/solid/esm/ChevronDownIcon.js
var ChevronDownIcon = __webpack_require__(13398);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/assets/animations/ArrowDown/ArrowDown.jsx




var ArrowDown = function(param) {
    var open = param.open, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronDownIcon/* default */.Z, {
        className: classnames_default()(className, "shrink-0 transition duration-300 ease-in-out", {
            "h-5 w-5": !className,
            "rotate-x-180": open
        })
    });
};
ArrowDown.defaultProps = {};
ArrowDown.propTypes = {
    open: prop_types_default().oneOfType([
        (prop_types_default()).bool,
        (prop_types_default()).string
    ])
};
/* harmony default export */ var ArrowDown_ArrowDown = (ArrowDown);

;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/assets/animations/ArrowDown/index.js



/***/ }),

/***/ 40325:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ LogosBrand_LogosBrand; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/assets/logos/LogosBrand/componentsMapping.js
/* provided dependency */ var process = __webpack_require__(34406);

var YemaIcons = {
    horizontal_black: dynamic_default()(function() {
        return __webpack_require__.e(/* import() */ 2923).then(__webpack_require__.t.bind(__webpack_require__, 82923, 23));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(82923)
                ];
            }
        }
    }),
    horizontal_white: dynamic_default()(function() {
        return __webpack_require__.e(/* import() */ 1166).then(__webpack_require__.t.bind(__webpack_require__, 41166, 23));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(41166)
                ];
            }
        }
    }),
    simple_black: dynamic_default()(function() {
        return __webpack_require__.e(/* import() */ 1561).then(__webpack_require__.t.bind(__webpack_require__, 61561, 23));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(61561)
                ];
            }
        }
    }),
    simple_white: dynamic_default()(function() {
        return __webpack_require__.e(/* import() */ 6616).then(__webpack_require__.t.bind(__webpack_require__, 66616, 23));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(66616)
                ];
            }
        }
    }),
    mundo_y: dynamic_default()(function() {
        return __webpack_require__.e(/* import() */ 1424).then(__webpack_require__.t.bind(__webpack_require__, 21424, 23));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(21424)
                ];
            }
        }
    }),
    square_black: dynamic_default()(function() {
        return __webpack_require__.e(/* import() */ 6474).then(__webpack_require__.t.bind(__webpack_require__, 56474, 23));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(56474)
                ];
            }
        }
    }),
    square_white: dynamic_default()(function() {
        return __webpack_require__.e(/* import() */ 8719).then(__webpack_require__.t.bind(__webpack_require__, 68719, 23));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(68719)
                ];
            }
        }
    })
};
var T3BIcons = {
    horizontal_black: dynamic_default()(function() {
        return __webpack_require__.e(/* import() */ 6330).then(__webpack_require__.t.bind(__webpack_require__, 6330, 23));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(6330)
                ];
            }
        }
    }),
    horizontal_white: dynamic_default()(function() {
        return __webpack_require__.e(/* import() */ 6330).then(__webpack_require__.t.bind(__webpack_require__, 6330, 23));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(6330)
                ];
            }
        }
    }),
    simple_black: dynamic_default()(function() {
        return __webpack_require__.e(/* import() */ 1380).then(__webpack_require__.t.bind(__webpack_require__, 1380, 23));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(1380)
                ];
            }
        }
    }),
    simple_white: dynamic_default()(function() {
        return __webpack_require__.e(/* import() */ 1380).then(__webpack_require__.t.bind(__webpack_require__, 1380, 23));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(1380)
                ];
            }
        }
    }),
    mundo_y: dynamic_default()(function() {
        return __webpack_require__.e(/* import() */ 6330).then(__webpack_require__.t.bind(__webpack_require__, 6330, 23));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(6330)
                ];
            }
        }
    }),
    square_black: dynamic_default()(function() {
        return __webpack_require__.e(/* import() */ 1380).then(__webpack_require__.t.bind(__webpack_require__, 1380, 23));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(1380)
                ];
            }
        }
    }),
    square_white: dynamic_default()(function() {
        return __webpack_require__.e(/* import() */ 1380).then(__webpack_require__.t.bind(__webpack_require__, 1380, 23));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(1380)
                ];
            }
        }
    })
};
var isStorefront3B = process.env.NEXT_PUBLIC_CONTEXT === "storefront_3b";
var IconsBrand = isStorefront3B ? T3BIcons : YemaIcons;

;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/assets/logos/LogosBrand/LogosBrand.jsx




var LogosBrand = function(param) {
    var type = param.type, className = param.className;
    if (!type || typeof type !== "string" || type.length === 0) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    var LogoBrand = IconsBrand[type] || IconsBrand.horizontal_black;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoBrand, {
        className: "max-h-16 " + className
    });
};
LogosBrand.displayName = "LogosBrand";
LogosBrand.propTypes = {
    type: prop_types.string.isRequired,
    className: prop_types.string
};
/* harmony default export */ var LogosBrand_LogosBrand = (LogosBrand);


/***/ }),

/***/ 68113:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Badge_Badge; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/atoms/Link/index.js
var Link = __webpack_require__(35384);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/atoms/Badge/Badge.jsx








var Badge = function(param) {
    var className = param.className, bgColor = param.bgColor, textColor = param.textColor, type = param.type, children = param.children, href = param.href, style = param.style;
    var _obj;
    var rootClass = classnames_default()(className, "inline-block font-body", (_obj = {
        "shadow-down text-small rounded-l-none rounded-r-sm px-2 py-1": type === "generic" || type === "initial" || type === "stockout",
        "text-small rounded-xxl px-2 py-1": type === "round",
        "shadow-down text-caption leading-tight border-solid border border-brand-primary-700 rounded-sm px-1 py-0": type === "discount",
        "shadow-down font-body font-body-normal text-small underline rounded-bl-md px-2 py-1 cursor-pointer": type === "linkTop",
        "shadow-down font-body font-body-normal text-small underline rounded-tl-md px-2 py-1 cursor-pointer": type === "linkBottom",
        "bg-brand-secondary-700": !bgColor && type === "generic",
        "bg-ui-success": !bgColor && type === "round",
        "bg-brand-tertiary-500": !bgColor && type === "initial",
        "bg-ui-gray-300": !bgColor && type === "stockout",
        "bg-ui-white": !bgColor && type === "discount"
    }, (0,_define_property/* default */.Z)(_obj, bgColor, bgColor), (0,_define_property/* default */.Z)(_obj, "text-ui-white", !textColor && (type === "generic" || type === "initial" || type === "round")), (0,_define_property/* default */.Z)(_obj, "text-ui-gray-900", !textColor && type === "stockout"), (0,_define_property/* default */.Z)(_obj, "text-brand-primary-700", !textColor && type === "discount"), (0,_define_property/* default */.Z)(_obj, "text-ui-black", !textColor && (type === "linkTop" || type === "linkBottom")), (0,_define_property/* default */.Z)(_obj, "font-body-normal ".concat(textColor), textColor), _obj));
    var colorRGB = "#FDF2F1";
    var colorRGBA = colorRGB + "80";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: rootClass,
        style: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, style), {
            backgroundColor: type === "linkBottom" || type === "linkTop" ? colorRGBA : ""
        }),
        children: type === "linkBottom" || type === "linkTop" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Link["default"], {
            href: href,
            children: children
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: children
        })
    });
};
Badge.defaultProps = {
    type: "generic"
};
Badge.propTypes = {
    className: prop_types.string,
    textColor: prop_types.string,
    bgColor: prop_types.string,
    /** Badge variants: intial, stock-out, generic, discount, etc. */ type: prop_types.oneOf([
        "generic",
        "round",
        "initial",
        "stockout",
        "discount",
        "linkTop",
        "linkBottom", 
    ]),
    children: prop_types.string.isRequired,
    href: prop_types.string
};
/* harmony default export */ var Badge_Badge = (Badge);

;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/atoms/Badge/index.js



/***/ }),

/***/ 66483:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70865);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96577);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var sf_modules__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37555);





/**
 * Use our custom loader on Google Cloud Functions, linked to Google Storage
 * instead of next default loader
 */ var customLoader = function(param) {
    var src = param.src, width = param.width, quality = param.quality;
    return sf_modules__WEBPACK_IMPORTED_MODULE_3__/* .imageTools.getOptimizedImageURL */ .d$.getOptimizedImageURL(src, {
        w: width,
        q: quality || 70
    });
};
var Image = function(props) {
    if (!props || !props.src) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    var imageLoader = props.src.startsWith("https://us-central1-yema-") ? {
        loader: customLoader
    } // YEMA CDN Loader
     : {};
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, imageLoader, props));
};
/* harmony default export */ __webpack_exports__["Z"] = (Image);


/***/ }),

/***/ 4740:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Image__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Image__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66483);



/***/ }),

/***/ 73769:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(13980);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39097);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);







var Link = function(_param) {
    var className = _param.className, context = _param.context, underline = _param.underline, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "className",
        "context",
        "underline",
        "children"
    ]);
    var href = props === null || props === void 0 ? void 0 : props.href;
    var rootClass = classnames__WEBPACK_IMPORTED_MODULE_2___default()(className, "cursor-pointer", {
        "relative inline-block underline": underline,
        "text-ui-error": context === "danger"
    });
    if (!href || href === "") {
        var linkProps = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            className: rootClass,
            "aria-label": (props === null || props === void 0 ? void 0 : props.label) || "",
            rel: (props === null || props === void 0 ? void 0 : props.target) === "_blank" ? "noopener noreferrer" : ""
        }, props);
        delete linkProps.shallow;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, linkProps), {
            children: children
        }));
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        className: rootClass
    }, props), {
        children: children
    }));
};
Link.defaultProps = {
    context: null,
    underline: true,
    target: "_self",
    shallow: false
};
Link.propTypes = {
    className: prop_types__WEBPACK_IMPORTED_MODULE_6__.string,
    style: prop_types__WEBPACK_IMPORTED_MODULE_6__.object,
    context: prop_types__WEBPACK_IMPORTED_MODULE_6__.oneOf([
        "",
        "danger"
    ]),
    underline: prop_types__WEBPACK_IMPORTED_MODULE_6__.bool,
    href: prop_types__WEBPACK_IMPORTED_MODULE_6__.oneOfType([
        prop_types__WEBPACK_IMPORTED_MODULE_6__.string,
        prop_types__WEBPACK_IMPORTED_MODULE_6__.object
    ]),
    prefetch: prop_types__WEBPACK_IMPORTED_MODULE_6__.bool,
    target: prop_types__WEBPACK_IMPORTED_MODULE_6__.string,
    onClick: prop_types__WEBPACK_IMPORTED_MODULE_6__.func,
    label: prop_types__WEBPACK_IMPORTED_MODULE_6__.string,
    shallow: prop_types__WEBPACK_IMPORTED_MODULE_6__.bool,
    children: prop_types__WEBPACK_IMPORTED_MODULE_6__.node
};
/* harmony default export */ __webpack_exports__["Z"] = (Link);


/***/ }),

/***/ 35384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* reexport safe */ _Link__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73769);



/***/ }),

/***/ 29832:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ProductPriceForQuantity; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13980);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var sf_modules__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37555);
/* harmony import */ var _Badge__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68113);





ProductPriceForQuantity.propTypes = {
    wrapperClassName: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    pricesWrapperClassName: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    discountsWrapperClassName: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    context: prop_types__WEBPACK_IMPORTED_MODULE_4__.oneOf([
        "pos",
        "cart",
        "checkout",
        "success",
        "profileOrder",
        "hit",
        "product-page",
        "modal",
        "default", 
    ]),
    product: prop_types__WEBPACK_IMPORTED_MODULE_4__.object,
    hideDiscounts: prop_types__WEBPACK_IMPORTED_MODULE_4__.bool
};
ProductPriceForQuantity.defaultProps = {
    context: "default",
    hideDiscounts: false
};
function ProductPriceForQuantity(param) {
    var wrapperClassName = param.wrapperClassName, pricesWrapperClassName = param.pricesWrapperClassName, discountsWrapperClassName = param.discountsWrapperClassName, hideDiscounts = param.hideDiscounts, context = param.context, product = param.product;
    if (!(product === null || product === void 0 ? void 0 : product.catalogPrice)) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    if (product.isGift) {
        var nbGifts = product.productsGifted || 1;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
            className: "font-semibold font-body text-normal leading-tight text-ui-gray-900",
            children: [
                "Regalo",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                    className: "ml-1 text-small font-body-regular text-ui-gray-500",
                    children: [
                        "(",
                        nbGifts,
                        " unidad",
                        nbGifts > 1 && "es",
                        ")"
                    ]
                })
            ]
        });
    }
    var regularPricePerUnit;
    var priceToPayPerUnit;
    var totalPriceToPay;
    var pricePerQuantityUnit;
    var sellingValue = Number(product.sellingValue);
    var refinedSellingValue = Number.isInteger(sellingValue) ? sellingValue : sellingValue.toFixed(1);
    var productQuantityForPrice = product.sellingUnit && "(".concat(refinedSellingValue, " ").concat(product.sellingUnit, ")");
    var isBuyingContext = false;
    switch(context){
        case "pos":
        case "cart":
        case "checkout":
            isBuyingContext = true;
            totalPriceToPay = product.totalPrice;
            priceToPayPerUnit = totalPriceToPay / product.billedQuantity;
            regularPricePerUnit = priceToPayPerUnit < product.catalogPrice.price ? product.catalogPrice.price : null;
            break;
        case "success":
        case "profileOrder":
            isBuyingContext = true;
            totalPriceToPay = product.paidPricing.totalPrice;
            priceToPayPerUnit = totalPriceToPay / product.billedQuantity;
            regularPricePerUnit = priceToPayPerUnit < product.paidPricing.priceUndiscounted ? product.paidPricing.priceUndiscounted : null;
            break;
        case "product-page":
            totalPriceToPay = null;
            priceToPayPerUnit = product.catalogPrice.discountedPrice;
            regularPricePerUnit = priceToPayPerUnit < product.catalogPrice.price ? product.catalogPrice.price : null;
            pricePerQuantityUnit = refinedSellingValue && "".concat(sf_modules__WEBPACK_IMPORTED_MODULE_2__/* .money.formatMoney */ .CZ.formatMoney(product.catalogPrice.discountedPrice / refinedSellingValue), " / ").concat(product.sellingUnit);
            break;
        default:
            totalPriceToPay = null;
            priceToPayPerUnit = product.catalogPrice.discountedPrice;
            regularPricePerUnit = priceToPayPerUnit < product.catalogPrice.price ? product.catalogPrice.price : null;
            productQuantityForPrice = product.sellingUnit && refinedSellingValue + " " + product.sellingUnit;
            break;
    }
    var saleByWeight = product.sellingType && product.sellingType !== "por-pieza";
    var showProductQuantityForPrice = !saleByWeight || context === "default";
    var discount = sf_modules__WEBPACK_IMPORTED_MODULE_2__/* .money.getDiscount */ .CZ.getDiscount(priceToPayPerUnit, regularPricePerUnit);
    var sellingPresentation = saleByWeight && refinedSellingValue ? " / ".concat(refinedSellingValue > 1 ? "".concat(refinedSellingValue, " ") : "").concat(product.sellingUnit) : product.isBundle ? " / pack" : " / pz";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(wrapperClassName, {
            "mt-1 flex w-full flex-col-reverse md:flex-row md:items-end md:justify-between": showProductQuantityForPrice
        }),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(pricesWrapperClassName, "mr-2 flex justify-start"),
                children: [
                    !hideDiscounts && regularPricePerUnit && discount ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(discountsWrapperClassName, "flex items-center"),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("mr-1", "font-body leading-tight line-through", "text-caption text-ui-gray-500"),
                                children: sf_modules__WEBPACK_IMPORTED_MODULE_2__/* .money.formatMoney */ .CZ.formatMoney(regularPricePerUnit)
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Badge__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                type: "discount",
                                children: discount
                            })
                        ]
                    }) : context !== "pos" && !hideDiscounts ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "h-4"
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-wrap items-center font-body text-normal",
                        children: [
                            !hideDiscounts && isBuyingContext && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "flex-shrink-0 text-sm font-body-bold text-ui-gray-900",
                                        children: sf_modules__WEBPACK_IMPORTED_MODULE_2__/* .money.formatMoney */ .CZ.formatMoney(totalPriceToPay)
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "mx-2 inline-block h-1 w-1 flex-shrink-0 rounded-full bg-brand-secondary-700"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("flex-shrink-0", isBuyingContext ? "leading-tight text-ui-gray-500" : "font-body-bold text-ui-gray-900", context === "hit" ? "text-caption" : "text-normal"),
                                children: [
                                    sf_modules__WEBPACK_IMPORTED_MODULE_2__/* .money.formatMoney */ .CZ.formatMoney(priceToPayPerUnit),
                                    context !== "default" && sellingPresentation
                                ]
                            })
                        ]
                    })
                ]
            }),
            showProductQuantityForPrice && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("flex-shrink-0 font-body leading-tight md:flex md:items-end", "text-left text-ui-gray-900 md:text-right", context === "product-page" ? "text-normal font-body-regular lg:flex-col" : "text-small font-body-regular"),
                children: [
                    pricePerQuantityUnit && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "hidden text-caption font-body-regular text-ui-gray-500 lg:block",
                        children: pricePerQuantityUnit
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "text-caption text-black",
                        children: productQuantityForPrice
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 38534:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(13980);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var reakit_Tooltip__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97988);
/* harmony import */ var reakit_Tooltip__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96247);
/* harmony import */ var reakit_Tooltip__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(63890);
/* harmony import */ var reakit_Tooltip__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(34301);







var Tooltip = function(param) {
    var uniqueId = param.uniqueId, anchorClassName = param.anchorClassName, tooltipBgColor = param.tooltipBgColor, arrowFillColor = param.arrowFillColor, placement = param.placement, showOnHover = param.showOnHover, tooltipContent = param.tooltipContent, children = param.children;
    // Prefix is required to target tooltip with CSS selector (see tailwind.scss)
    var id = "aria-tooltip-" + uniqueId;
    var tooltipState = (0,reakit_Tooltip__WEBPACK_IMPORTED_MODULE_3__/* .useTooltipState */ .K)({
        baseId: id,
        padding: 5,
        gutter: 12,
        visible: showOnHover ? undefined : true,
        placement: placement,
        unstable_fixed: true,
        unstable_flip: true
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        tooltipState.place(placement);
    }, [
        tooltipState.place,
        placement
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(reakit_Tooltip__WEBPACK_IMPORTED_MODULE_4__/* .TooltipReference */ .v, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, tooltipState), {
                as: "div",
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(anchorClassName, {
                    "cursor-pointer": showOnHover
                }),
                children: children
            })),
            tooltipContent && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(reakit_Tooltip__WEBPACK_IMPORTED_MODULE_7__/* .Tooltip */ .u, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                baseId: id
            }, tooltipState), {
                visible: showOnHover ? tooltipState.visible : true,
                unstable_portal: false,
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(tooltipBgColor, "max-w-sm rounded-sm p-2 text-center text-ui-black", placement === "top" ? "shadow-up" : "shadow-down"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(reakit_Tooltip__WEBPACK_IMPORTED_MODULE_8__/* .TooltipArrow */ .C, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, tooltipState), {
                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("h-6 w-6", arrowFillColor)
                    })),
                    typeof tooltipContent === "string" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "mb-0",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("small", {
                            children: tooltipContent
                        })
                    }) : tooltipContent
                ]
            }))
        ]
    });
};
Tooltip.displayName = "Tooltip";
Tooltip.defaultProps = {
    tooltipBgColor: "bg-brand-primary-300",
    arrowFillColor: "fill-brand-primary-300",
    placement: "auto",
    showOnHover: true
};
Tooltip.propTypes = {
    uniqueId: prop_types__WEBPACK_IMPORTED_MODULE_9__.string.isRequired,
    anchorClassName: prop_types__WEBPACK_IMPORTED_MODULE_9__.string,
    tooltipClassName: prop_types__WEBPACK_IMPORTED_MODULE_9__.string,
    tooltipBgColor: prop_types__WEBPACK_IMPORTED_MODULE_9__.string,
    arrowFillColor: prop_types__WEBPACK_IMPORTED_MODULE_9__.string,
    placement: prop_types__WEBPACK_IMPORTED_MODULE_9__.oneOf([
        "auto-start",
        "auto",
        "auto-end",
        "top",
        "bottom",
        "left",
        "right", 
    ]),
    showOnHover: prop_types__WEBPACK_IMPORTED_MODULE_9__.bool,
    /** Text to show inside the tooltip */ tooltipContent: prop_types__WEBPACK_IMPORTED_MODULE_9__.oneOfType([
        prop_types__WEBPACK_IMPORTED_MODULE_9__.string,
        prop_types__WEBPACK_IMPORTED_MODULE_9__.node
    ]),
    /** Tooltip width */ children: prop_types__WEBPACK_IMPORTED_MODULE_9__.node
};
/* harmony default export */ __webpack_exports__["Z"] = (Tooltip);


/***/ }),

/***/ 63129:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* reexport safe */ _Tooltip__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Tooltip__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38534);



/***/ }),

/***/ 11651:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(13980);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react_modal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37149);
/* harmony import */ var react_modal__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_modal__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _atoms_ModalHeader__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71200);
/* harmony import */ var _atoms_ModalBody__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26052);










var FullModal = function(_param) {
    var onClose = _param.onClose, isOpen = _param.isOpen, className = _param.className, overlayClassName = _param.overlayClassName, headerBackgroundColor = _param.headerBackgroundColor, headerClassName = _param.headerClassName, headerShadow = _param.headerShadow, style = _param.style, title = _param.title, children = _param.children, headerContent = _param.headerContent, otherProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "onClose",
        "isOpen",
        "className",
        "overlayClassName",
        "headerBackgroundColor",
        "headerClassName",
        "headerShadow",
        "style",
        "title",
        "children",
        "headerContent"
    ]);
    var baseOverlayClass = classnames__WEBPACK_IMPORTED_MODULE_3___default()("fixed top-0 right-0 bottom-0 left-0 flex items-center justify-center pointer-events-auto w-full", "opacity-100 z-modal transition duration-200 ease-modal", [
        "".concat(overlayClassName ? overlayClassName : "bg-ui-white")
    ]);
    var baseClass = classnames__WEBPACK_IMPORTED_MODULE_3___default()(className, "max-w-4.5xl relative w-full md:py-20 flex h-full min-h-screen flex-col items-center justify-start");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((react_modal__WEBPACK_IMPORTED_MODULE_2___default()), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        overlayClassName: baseOverlayClass,
        className: baseClass,
        isOpen: isOpen,
        closeOnEscape: true,
        onRequestClose: onClose,
        ariaHideApp: false
    }, otherProps), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_ModalHeader__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                title: title,
                titleSize: "text-h3 sm:text-h2 font-heading-regular",
                type: "full",
                headerBackground: headerBackgroundColor ? headerBackgroundColor : "bg-transparent",
                onClose: onClose,
                containerClassName: classnames__WEBPACK_IMPORTED_MODULE_3___default()(headerClassName, "sm:mb-12 w-full", {
                    "shadow-down": headerShadow
                }),
                children: headerContent
            }),
            children && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_ModalBody__WEBPACK_IMPORTED_MODULE_5__["default"], {
                className: "w-full overflow-y-scroll px-4",
                children: children
            })
        ]
    }));
};
FullModal.displayName = "FullModal";
FullModal.defaultProps = {
    isOpen: false
};
FullModal.propTypes = {
    onClose: prop_types__WEBPACK_IMPORTED_MODULE_9__.func,
    isOpen: prop_types__WEBPACK_IMPORTED_MODULE_9__.bool.isRequired,
    className: prop_types__WEBPACK_IMPORTED_MODULE_9__.string,
    overlayClassName: prop_types__WEBPACK_IMPORTED_MODULE_9__.string,
    headerBackgroundColor: prop_types__WEBPACK_IMPORTED_MODULE_9__.string,
    headerClassName: prop_types__WEBPACK_IMPORTED_MODULE_9__.string,
    headerShadow: prop_types__WEBPACK_IMPORTED_MODULE_9__.bool,
    style: prop_types__WEBPACK_IMPORTED_MODULE_9__.object,
    title: prop_types__WEBPACK_IMPORTED_MODULE_9__.oneOfType([
        prop_types__WEBPACK_IMPORTED_MODULE_9__.string,
        prop_types__WEBPACK_IMPORTED_MODULE_9__.node
    ]),
    children: prop_types__WEBPACK_IMPORTED_MODULE_9__.node.isRequired,
    headerContent: prop_types__WEBPACK_IMPORTED_MODULE_9__.oneOfType([
        prop_types__WEBPACK_IMPORTED_MODULE_9__.string,
        prop_types__WEBPACK_IMPORTED_MODULE_9__.node
    ])
};
/* harmony default export */ __webpack_exports__["default"] = (FullModal);


/***/ }),

/***/ 84521:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* reexport safe */ _FullModal__WEBPACK_IMPORTED_MODULE_0__["default"]; }
/* harmony export */ });
/* harmony import */ var _FullModal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11651);



/***/ }),

/***/ 23613:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ Header_Header; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../packages/sf-modules/src/index.js + 26 modules
var src = __webpack_require__(37555);
// EXTERNAL MODULE: ../../packages/icons/solid/esm/LocationHomeIcon.js
var LocationHomeIcon = __webpack_require__(83150);
// EXTERNAL MODULE: ../../packages/icons/solid/esm/LocationUnknownIcon.js
var LocationUnknownIcon = __webpack_require__(13424);
// EXTERNAL MODULE: ../../packages/icons/solid/esm/SearchIcon.js
var SearchIcon = __webpack_require__(67566);
// EXTERNAL MODULE: ../../packages/icons/solid/esm/UserIcon.js
var UserIcon = __webpack_require__(32586);
// EXTERNAL MODULE: ../../packages/icons/solid/esm/CartIcon.js
var CartIcon = __webpack_require__(55644);
// EXTERNAL MODULE: ../../packages/icons/solid/esm/CloseIcon.js
var CloseIcon = __webpack_require__(36600);
// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/assets/logos/LogosBrand/LogosBrand.jsx + 1 modules
var LogosBrand = __webpack_require__(40325);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/atoms/SearchInput/SearchInput.jsx










// Temporal component until refactor of ActionInput and Header is made.
var SearchInput = function(_param) {
    var inputKey = _param.inputKey, icon = _param.icon, value = _param.value, placeholder = _param.placeholder, onClick = _param.onClick, onChange = _param.onChange, className = _param.className, disabled = _param.disabled, style = _param.style, removeAccents = _param.removeAccents, upperCase = _param.upperCase, autoFocus = _param.autoFocus, _autocomplete = _param.autocomplete, autocomplete = _autocomplete === void 0 ? "" : _autocomplete, onKeyDown = _param.onKeyDown, withIcon = _param.withIcon, iconPosition = _param.iconPosition, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "inputKey",
        "icon",
        "value",
        "placeholder",
        "onClick",
        "onChange",
        "className",
        "disabled",
        "style",
        "removeAccents",
        "upperCase",
        "autoFocus",
        "autocomplete",
        "onKeyDown",
        "withIcon",
        "iconPosition"
    ]);
    var node = (0,react.useRef)();
    var ref = (0,react.useState)(false), setIsOpenedDropdown = ref[1];
    var handleClickOutside = function(event) {
        if (node.current && !node.current.contains(event.target)) {
            setIsOpenedDropdown(false);
        }
    };
    var ref1 = (0,react.useState)({
        name: value ? value : "",
        multiline: "Controlled"
    }), values = ref1[0], setValues = ref1[1];
    var action = function(name) {
        return function(event) {
            setValues((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, values), (0,_define_property/* default */.Z)({}, name, event.target.value)));
            if (onChange) onChange(event.target.value);
        };
    };
    /**
     * On key down
     * @param e
     */ var handleKeyDown = function(e) {
        if (e.key === "Enter") onClick(values.name);
        if (onKeyDown) onKeyDown(e);
    };
    (0,react.useEffect)(function() {
         true && document.addEventListener("click", handleClickOutside, false);
        return function() {
             true && document.removeEventListener("click", handleClickOutside, false);
        };
    }, []);
    (0,react.useEffect)(function() {
        if (value !== null && value !== undefined && removeAccents) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            value = (0,src/* removeAccentsLowerCase */.vO)(value);
        }
        if (value !== null && value !== undefined && upperCase) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            value = value.toUpperCase();
        }
        setValues({
            name: value ? value : "",
            multiline: "Controlled"
        });
    }, [
        value
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        ref: node,
        className: "flex h-inherit w-full",
        style: style
    }, otherProps), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()("input box-border flex w-full rounded-sm border border-ui-black bg-ui-white py-1.5 text-ui-black", iconPosition === "left" && "flex-row-reverse", iconPosition === "right" && "pl-4"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                    type: "text",
                    value: values.name,
                    className: "w-full rounded-none border-0 p-0 font-body text-small leading-none outline-none ring-0 ring-transparent focus:ring-0",
                    id: inputKey,
                    name: inputKey,
                    placeholder: placeholder,
                    onChange: action("name"),
                    onKeyDown: handleKeyDown,
                    onClick: function() {
                        return setIsOpenedDropdown(true);
                    },
                    disabled: disabled,
                    title: placeholder,
                    autoFocus: autoFocus,
                    autoComplete: autocomplete
                }, inputKey),
                withIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mx-2 flex cursor-pointer items-center justify-center",
                    onClick: function() {
                        return onClick(values.name);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchIcon/* default */.Z, {
                        className: "w-6"
                    })
                })
            ]
        })
    }));
};
SearchInput.displayName = "SearchInput";
SearchInput.defaultProps = {
    disabled: false,
    removeAccents: false,
    upperCase: false,
    autoFocus: false,
    onClick: function() {},
    iconPosition: "right"
};
SearchInput.propTypes = {
    inputKey: prop_types.string,
    disabled: prop_types.bool,
    value: prop_types.string,
    placeholder: prop_types.string,
    className: prop_types.string,
    style: prop_types.object,
    removeAccents: prop_types.bool,
    upperCase: prop_types.bool,
    autoFocus: prop_types.bool,
    onClick: prop_types.func,
    onKeyDown: prop_types.func,
    iconPosition: prop_types.oneOf([
        "right",
        "left"
    ])
};
/* harmony default export */ var SearchInput_SearchInput = (SearchInput);

;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/atoms/SearchInput/index.js


// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/atoms/Link/index.js
var Link = __webpack_require__(35384);
// EXTERNAL MODULE: ../../node_modules/use-media/lib/index.js
var lib = __webpack_require__(81145);
// EXTERNAL MODULE: ../../packages/icons/solid/esm/ChevronDownIcon.js
var ChevronDownIcon = __webpack_require__(13398);
;// CONCATENATED MODULE: ../../packages/designkit/src/hooks/useKeyPress.js

/**
 * useKeyPress
 * @param {string} key - the name of the key to respond to, compared against event.key
 * @param {function} action - the action to perform on key press
 */ function useKeypress(key, action) {
    (0,react.useEffect)(function() {
        var onKeyup = function onKeyup(e) {
            if (e.key === key) action();
        };
        window.addEventListener("keyup", onKeyup);
        return function() {
            return window.removeEventListener("keyup", onKeyup);
        };
    }, []);
};

// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/atoms/Image/index.js
var Image = __webpack_require__(4740);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../../node_modules/@headlessui/react/dist/components/disclosure/disclosure.js
var disclosure = __webpack_require__(69309);
// EXTERNAL MODULE: ../../node_modules/@headlessui/react/dist/components/transitions/transition.js + 3 modules
var transition = __webpack_require__(68810);
// EXTERNAL MODULE: ../../node_modules/@headlessui/react/dist/components/dialog/dialog.js + 9 modules
var dialog = __webpack_require__(42387);
// EXTERNAL MODULE: ../../packages/icons/solid/esm/ArrowRightIcon.js
var ArrowRightIcon = __webpack_require__(14830);
;// CONCATENATED MODULE: ../../packages/designkit/src/hooks/useWindowDimensions.js

function getWindowDimensions() {
    var width = window.innerWidth, height = window.innerHeight;
    return {
        width: width,
        height: height
    };
}
function useWindowDimensions() {
    var ref = (0,react.useState)(getWindowDimensions()), windowDimensions = ref[0], setWindowDimensions = ref[1];
    (0,react.useEffect)(function() {
        var handleResize = function handleResize() {
            setWindowDimensions(getWindowDimensions());
        };
        window.addEventListener("resize", handleResize);
        return function() {
            return window.removeEventListener("resize", handleResize);
        };
    }, []);
    return windowDimensions;
};

// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/atoms/Button/index.js + 1 modules
var Button = __webpack_require__(62772);
// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/assets/animations/ArrowDown/index.js + 1 modules
var ArrowDown = __webpack_require__(81666);
// EXTERNAL MODULE: ../../packages/designkit/src/assets/trolley.png
var trolley = __webpack_require__(62877);
var trolley_default = /*#__PURE__*/__webpack_require__.n(trolley);
;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/molecules/AislesMenuMobile/AislesMenuMobile.jsx












var CategoriesLinkItem = function(param) {
    var href = param.href, icon = param.icon, label = param.label, name = param.name, lvl = param.lvl, onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
            className: "relative mr-auto flex w-full items-center justify-center gap-2 border-b border-ui-gray-300 px-3 py-4 text-h5 transition-all",
            href: href,
            underline: false,
            variants: "custom",
            size: "full",
            onClick: onClick,
            children: [
                icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    layout: "fixed",
                    width: 14,
                    height: 14,
                    src: icon,
                    alt: label
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: classnames_default()("mb-0 mr-auto font-body text-h5 font-body-normal", {
                        "font-body-bold": lvl === 0
                    }),
                    children: name
                })
            ]
        })
    });
};
var CategoriesButtonItem = function(param) {
    var _lvl = param.lvl, lvl = _lvl === void 0 ? 0 : _lvl, item = param.item, hasChild = param.hasChild, currentCategory = param.currentCategory, refinedMenu = param.refinedMenu;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex w-full items-center justify-start gap-2",
        children: [
            (item.link === currentCategory.link || item.link === "/s" && currentCategory.link === "/s") && /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightIcon/* default */.Z, {
                className: "h-4 w-4 "
            }),
            item.icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                layout: "fixed",
                width: 14,
                height: 14,
                src: item.icon,
                alt: item.name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: classnames_default()("mb-0 font-body text-h5 font-body-normal", {
                    "font-body-bold": lvl === 0
                }, item.link === currentCategory.link ? "mr-0" : "mr-auto"),
                children: item.name
            }),
            hasChild && /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDown/* default */.Z, {
                className: "ml-auto h-5 w-5",
                open: refinedMenu[lvl] === item.algolia
            })
        ]
    });
};
var CategoriesPanel = function(param) {
    var refinedMenu = param.refinedMenu, setRefinedMenu = param.setRefinedMenu, currentCategory = param.currentCategory, aisle = param.aisle, subCat = param.subCat, _lvl = param.lvl, lvl = _lvl === void 0 ? 1 : _lvl, handleCloseModal = param.handleCloseModal;
    var handleToggleCategory = function(algolia, hasChild) {
        var refinedMenuCopy = (0,_to_consumable_array/* default */.Z)(refinedMenu);
        refinedMenuCopy[lvl] = refinedMenuCopy[lvl] === algolia ? "" : algolia;
        // if (refinedMenuCopy[lvl - 1] !== aisle.algolia || refinedMenuCopy[lvl - 1] === "") {
        if (!hasChild) handleCloseModal();
        setRefinedMenu(refinedMenuCopy);
    };
    if (!subCat || subCat.length <= 0) return "";
    return(// <ul className="pl-5 space-y-6 bg-brand-tertiary-100">
    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
        className: "bg-brand-tertiary-100 pl-5",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoriesLinkItem, {
                href: aisle.link,
                label: "subcategoria-".concat(lvl, "-todo"),
                name: "Todo ".concat(aisle.name),
                lvl: lvl,
                onClick: handleCloseModal
            }),
            subCat && subCat.map(function(subcategory, index) {
                var child = subcategory.subcategories;
                var hasChild = child && child.length > 0;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(disclosure/* Disclosure */.p, {
                    as: "li",
                    className: "pl-5",
                    children: function(param) {
                        var open = param.open;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(disclosure/* Disclosure.Button */.p.Button, {
                                    as: Button/* default */.Z,
                                    className: "relative mr-auto flex w-full border-b border-ui-gray-300 px-3 py-4 text-h5 transition-all",
                                    href: !hasChild ? subcategory.link : "",
                                    underline: false,
                                    variants: "custom",
                                    size: "full",
                                    onClick: function() {
                                        return handleToggleCategory(subcategory.algolia, hasChild);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoriesButtonItem, {
                                        className: "pl-5",
                                        lvl: 1,
                                        item: subcategory,
                                        hasChild: hasChild,
                                        currentCategory: currentCategory,
                                        refinedMenu: refinedMenu
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(disclosure/* Disclosure.Panel */.p.Panel, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "grid grid-cols-1 items-start gap-y-10 gap-x-6",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoriesPanel, {
                                            refinedMenu: refinedMenu,
                                            setRefinedMenu: setRefinedMenu,
                                            currentCategory: currentCategory,
                                            aisle: subcategory,
                                            subCat: child,
                                            lvl: lvl + 1,
                                            handleCloseModal: handleCloseModal
                                        })
                                    })
                                })
                            ]
                        });
                    }
                }, "subcategoria-" + index);
            })
        ]
    }));
};
// AISLES
var AislesMenuMobile = function(param) {
    var aislesCategories = param.aislesCategories, currentCategory = param.currentCategory, searchUrl = param.searchUrl, refinedMenu = param.refinedMenu, setRefinedMenu = param.setRefinedMenu, isPOS = param.isPOS, navBarHeight = param.navBarHeight;
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    var height = useWindowDimensions().height;
    var posNavBarHeight = navBarHeight + 40;
    var calcViewportHeight = height - (isPOS ? posNavBarHeight : navBarHeight);
    var dropdownItemName = currentCategory && currentCategory.name ? "".concat(currentCategory.name, " ") : "Pasillos";
    var handleClosePanel = function() {
        setTimeout(function() {
            return setOpen(false);
        }, 100);
    };
    var toogleMenuPanel = function(itemPanelIsOpened) {
        if (itemPanelIsOpened) setOpen(false);
        else setTimeout(function() {
            return setOpen(true);
        }, 100);
    };
    var handleToggleAisle = function(algolia, hasSubCat) {
        var refinedMenuCopy = (0,_to_consumable_array/* default */.Z)(refinedMenu);
        refinedMenuCopy[0] = refinedMenu[0] === algolia ? "" : algolia;
        setRefinedMenu(refinedMenuCopy);
        if (!hasSubCat) handleClosePanel();
    };
    if (aislesCategories && aislesCategories.length > 0) {
        var aislesPanelIsOpen = open;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "z-40 flex h-full flex-1 items-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "group flex h-full cursor-pointer items-center justify-center font-heading text-h5 text-ui-white",
                        onClick: function() {
                            return toogleMenuPanel(aislesPanelIsOpen);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: dropdownItemName
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDown/* default */.Z, {
                                open: open,
                                className: "ml-2 h-5 w-5"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition.Root */.u.Root, {
                    show: open,
                    as: react.Fragment,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* Dialog */.V, {
                        as: "div",
                        className: "relative",
                        onClose: handleClosePanel,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()("fixed z-100 flex h-screen w-full bg-ui-white", {
                                "max-w-md": isPOS
                            }),
                            style: {
                                maxHeight: "".concat(calcViewportHeight, "px"),
                                top: "".concat(isPOS ? posNavBarHeight : navBarHeight, "px")
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition.Child */.u.Child, {
                                as: react.Fragment,
                                enter: "transition ease-in-out transform",
                                enterFrom: "-translate-y-6 opacity-0",
                                enterTo: "translate-y-0 opacity-100",
                                leave: "transition ease-in-out transform",
                                leaveFrom: "translate-y-0 opacity-100",
                                leaveTo: "-translate-y-6 opacity-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* Dialog.Panel */.V.Panel, {
                                    as: "ul",
                                    className: "relative flex h-full w-full flex-col overflow-y-auto bg-ui-white pb-12 shadow-xl",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoriesLinkItem, {
                                            href: searchUrl,
                                            icon: (trolley_default()),
                                            label: "categoria-todos-productos",
                                            name: "Todos los productos"
                                        }),
                                        aislesCategories.map(function(aisle, index) {
                                            var subCat = aisle.categories;
                                            var hasSubCat = subCat !== undefined && subCat.length > 0;
                                            // PASILLOS - Comida - Bebés - Cuidado personal
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(disclosure/* Disclosure */.p, {
                                                as: "li",
                                                children: function(param) {
                                                    var open = param.open;
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(disclosure/* Disclosure.Button */.p.Button, {
                                                                as: Button/* default */.Z,
                                                                className: "items-left mr-auto flex w-full items-center justify-between gap-2 border-b border-ui-gray-300 px-3 py-4 text-h5 transition-all",
                                                                href: !hasSubCat ? aisle.link : "",
                                                                underline: false,
                                                                variants: "custom",
                                                                size: "full",
                                                                onClick: function() {
                                                                    return handleToggleAisle(aisle.algolia, hasSubCat);
                                                                },
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoriesButtonItem, {
                                                                    item: aisle,
                                                                    hasChild: hasSubCat,
                                                                    currentCategory: currentCategory,
                                                                    refinedMenu: refinedMenu
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(disclosure/* Disclosure.Panel */.p.Panel, {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "grid grid-cols-1 items-start gap-y-10 gap-x-6",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoriesPanel, {
                                                                        refinedMenu: refinedMenu,
                                                                        setRefinedMenu: setRefinedMenu,
                                                                        currentCategory: currentCategory,
                                                                        aisle: aisle,
                                                                        subCat: subCat,
                                                                        handleCloseModal: handleClosePanel
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    });
                                                }
                                            }, index);
                                        })
                                    ]
                                })
                            })
                        })
                    })
                })
            ]
        });
    }
};
AislesMenuMobile.displayName = "AislesMenuMobile";
AislesMenuMobile.defaultProps = {};
AislesMenuMobile.propTypes = {
    aislesCategories: (prop_types_default()).array,
    currentCategory: (prop_types_default()).object,
    searchUrl: (prop_types_default()).string,
    isMobile: (prop_types_default()).bool,
    refinedMenu: (prop_types_default()).array,
    setRefinedMenu: (prop_types_default()).func
};
/* harmony default export */ var AislesMenuMobile_AislesMenuMobile = (AislesMenuMobile);

;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/molecules/AislesMenuMobile/index.js


// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../packages/icons/solid/esm/ChevronRightIcon.js
var ChevronRightIcon = __webpack_require__(12073);
;// CONCATENATED MODULE: ../../packages/designkit/src/hooks/useClientRect.js

/**
 * Hook to get element dimensions
 * @param {boolean} load
 *
 */ function useClientRect(load) {
    var ref = (0,react.useState)(), rect = ref[0], setRect = ref[1];
    var ref1 = (0,react.useCallback)(function(el) {
        if (el !== null) {
            setRect(el.getBoundingClientRect());
        }
    }, [
        load
    ]);
    return [
        rect,
        ref1
    ];
};

;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/molecules/AislesMenu/AislesMenu.jsx









// CATEGORIES ITEM
var CategoriesItem = /*#__PURE__*/ react.memo(function(param) {
    var category = param.category, index = param.index, onClick = param.onClick, row = param.row;
    var subCat = category.subcategories ? category.subcategories : category.categories;
    var ref = (0,react.useState)(null), activeSubCat = ref[0], setActiveSubCat = ref[1];
    var handleHoverSubCat = function(id) {
        return setActiveSubCat(id);
    };
    var handleLeaveSubCat = function() {
        return setActiveSubCat(null);
    };
    var ref1 = (0,react.useState)(false), load = ref1[0], loaded = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)(useClientRect(load), 2), rect = ref2[0], ref3 = ref2[1];
    var ref4 = (0,react.useState)(1), gridRows = ref4[0], setGridRows = ref4[1];
    (0,react.useEffect)(function() {
        if (category.link) loaded(true);
    }, [
        category.link
    ]);
    (0,react.useEffect)(function() {
        rect && setGridRows(Math.ceil(rect.height / parseInt(row)));
    }, [
        rect
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "w-full justify-self-center",
        style: {
            gridRowEnd: "span ".concat(gridRows)
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            ref: ref3,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link["default"], {
                    href: category.link,
                    onClick: onClick,
                    underline: false,
                    className: "transition-color relative mb-0 mr-auto flex items-center px-2 py-1 font-body text-small font-body-bold duration-200 ease-easeInOutQuad hover:bg-brand-tertiary-700 hover:bg-opacity-10",
                    label: "categoria-".concat(index),
                    children: [
                        category.icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                            layout: "fixed",
                            width: 16,
                            height: 16,
                            src: category.icon,
                            alt: category.name
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: classnames_default()({
                                "ml-1": category.icon
                            }),
                            children: category.name
                        })
                    ]
                }),
                subCat && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: "pb-2",
                    children: subCat.map(function(subCategory, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "group",
                            onMouseEnter: function() {
                                return handleHoverSubCat(i);
                            },
                            onMouseLeave: function() {
                                return handleLeaveSubCat(i);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link["default"], {
                                href: subCategory.link,
                                onClick: onClick,
                                underline: false,
                                label: "subcategoria-".concat(i),
                                className: classnames_default()("transition-color mb-0 flex bg-opacity-10 py-1 px-2 font-body text-small font-body-regular leading-snug text-ui-black duration-200 ease-easeInOutQuad", {
                                    "bg-brand-tertiary-700": i === activeSubCat
                                }),
                                children: subCategory.name
                            })
                        }, "subcategoria-" + i);
                    })
                })
            ]
        })
    });
});
// CATEGORIES & SUBCATEGORIES
var CategoriesMenu = function(param) {
    var aisle = param.aisle, onCloseMenu = param.onCloseMenu;
    var categories = aisle.categories;
    var defaultGridRow = 27;
    var columnWidth = 240;
    if (!categories || !categories.length) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "absolute top-0 left-[216px] flex h-full max-h-full w-[calc(100%-216px)] flex-col justify-start space-y-2 overflow-auto bg-brand-tertiary-100 py-3 pl-2 pr-3 xl:pr-2",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center justify-between border-b border-ui-gray-300 px-2 pb-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link["default"], {
                        underline: false,
                        href: aisle.link,
                        onClick: onCloseMenu,
                        className: "mb-0 text-h4 font-heading-medium",
                        children: aisle.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link["default"], {
                        underline: false,
                        href: aisle.link,
                        onClick: onCloseMenu,
                        className: "group-scope relative text-small",
                        children: [
                            "Ver todo ",
                            aisle.name,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "group-scope-hover:scale-100 absolute bottom-0 left-0 hidden h-px w-full origin-left transform bg-ui-black transition duration-200 ease-out md:scale-0 lg:block"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "m-0 grid h-[calc(100%-44px)] gap-0",
                style: {
                    gridTemplateColumns: "repeat(auto-fill, minmax(".concat(columnWidth, "px, 1fr))"),
                    gridAutoRows: "".concat(defaultGridRow, "px")
                },
                children: categories.map(function(category, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoriesItem, {
                        category: category,
                        index: index,
                        onClick: onCloseMenu,
                        row: defaultGridRow
                    }, "categoria-" + index);
                })
            })
        ]
    });
};
var AislesMenuItem = /*#__PURE__*/ react.memo(function(param) {
    var index = param.index, aisle = param.aisle, activeAisle = param.activeAisle, handleToggleAisle = param.handleToggleAisle, onCloseMenu = param.onCloseMenu;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
        onMouseEnter: function() {
            return handleToggleAisle(index);
        },
        onMouseLeave: function() {
            return handleToggleAisle(index);
        },
        className: "group-scope",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("group-scope-hover:bg-brand-tertiary-100 group-scope-hover:bg-opacity-100 relative flex items-center gap-2 px-3 py-2 transition-all duration-200 ease-easeInOutQuad", {
                    "bg-brand-tertiary-100 bg-opacity-100": index === activeAisle
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mb-0 mr-auto font-body text-small font-body-bold",
                        children: aisle.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronRightIcon/* default */.Z, {
                        className: classnames_default()("group-scope-hover:translate-x-1 mr-1 block w-6 transform transition-transform duration-200 ease-easeInOutQuad")
                    })
                ]
            }),
            index === activeAisle && /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoriesMenu, {
                aisle: aisle,
                onCloseMenu: onCloseMenu
            })
        ]
    });
});
// AISLES
var AislesMenu = function(param) {
    var aislesCategories = param.aislesCategories, onCloseMenu = param.onCloseMenu;
    var ref = (0,react.useState)(0), activeAisle = ref[0], setActiveAisle = ref[1];
    var ref1 = (0,react.useState)(false), isTouch = ref1[0], setIsTouch = ref1[1];
    var handleToggleAisle = function(index) {
        return setActiveAisle(index);
    };
    (0,react.useEffect)(function() {
        if (typeof document !== "undefined") {
            setIsTouch("ontouchstart" in document.documentElement);
        }
    }, []);
    if (!aislesCategories || !aislesCategories.length) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()("absolute top-[40px] left-[2rem] flex h-[70vh] max-h-[648px] w-[calc(100%-4rem)] transform overflow-auto shadow-down", {
            "lg:h-[64vh]": isTouch
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
            className: "mb-0 w-[216px] bg-brand-tertiary-500 py-4",
            children: aislesCategories.map(function(aisle, index) {
                return(// PASILLOS
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AislesMenuItem, {
                    index: index,
                    aisle: aisle,
                    activeAisle: activeAisle,
                    handleToggleAisle: handleToggleAisle,
                    onCloseMenu: onCloseMenu
                }, "categoria-" + index));
            })
        })
    });
};
AislesMenu.displayName = "AislesMenu";
AislesMenuItem.displayName = "AislesMenuItem";
CategoriesItem.displayName = "CategoriesItem";
AislesMenu.defaultProps = {};
AislesMenu.propTypes = {
    aislesCategories: (prop_types_default()).array,
    onCloseMenu: (prop_types_default()).func
};
/* harmony default export */ var AislesMenu_AislesMenu = (AislesMenu);

;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/molecules/AislesMenu/index.js


;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/molecules/CategoryMenu/CategoryMenu.jsx











// NAVBAR CONTAINER
var NavItem = /*#__PURE__*/ react.memo(function(param) {
    var className = param.className, icon = param.icon, label = param.label, name = param.name, children = param.children, href = param.href, onClick = param.onClick, onMouseEnter = param.onMouseEnter, onMouseLeave = param.onMouseLeave;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
        className: classnames_default()(className, "group flex w-auto items-center justify-center"),
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link["default"], {
                className: classnames_default()("group flex h-full items-center justify-center p-1 text-ui-white transition-all duration-300"),
                underline: false,
                label: label,
                onClick: onClick,
                href: href ? href : null,
                children: [
                    icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        layout: "fixed",
                        width: 16,
                        height: 16,
                        src: icon,
                        alt: name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: classnames_default()("mb-0 font-heading text-h4 font-heading-medium", {
                            "ml-3.5": icon
                        }),
                        children: name
                    }),
                    children && /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronDownIcon/* default */.Z, {
                        className: "ml-4 w-6 transform text-ui-white transition-transform duration-200 ease-easeInOutQuad group-hover:translate-y-0.5"
                    })
                ]
            }),
            children
        ]
    });
});
// *** RENDER COMPONENT
var CategoryMenu = function(param) {
    var currentCategory = param.currentCategory, menuCategories = param.menuCategories, searchUrl = param.searchUrl, isPOS = param.isPOS, backgroundCustom = param.backgroundCustom, navBarHeight = param.navBarHeight;
    var isMobile = (0,lib/* default */.ZP)({
        maxWidth: 1023
    });
    var mainMenu = !isPOS && menuCategories.filter(function(f) {
        return !f.algolia.includes("Pasillos");
    });
    var aislesMenu = !isPOS && menuCategories.filter(function(f) {
        return f.algolia.includes("Pasillos");
    });
    var ref = (0,react.useState)([
        "",
        "",
        ""
    ]), refinedMenu = ref[0], setRefinedMenu = ref[1];
    var ref1 = (0,react.useState)(false), openMenu = ref1[0], setOpenMenu = ref1[1];
    var handleHoverMenu = function() {
        setOpenMenu(true);
    };
    var handleLeaveMenu = function() {
        setOpenMenu(false);
    };
    useKeypress("Escape", function() {
        return handleLeaveMenu();
    });
    (0,react.useEffect)(function() {
        // const bodyElement = typeof window !== 'undefined' ? document.body : undefined;
        // if (typeof bodyElement !== 'undefined' && bodyElement !== null)
        //     bodyElement.style.overflow = 'auto';
        // Auto open current category menu
        if (currentCategory && currentCategory.algolia) {
            var levels = currentCategory.algolia.split(" > ");
            var level1 = levels.length >= 1 ? levels[0] : "";
            var level2 = levels.length >= 2 ? "".concat(levels[0], " > ").concat(levels[1]) : "";
            var level3 = levels.length >= 3 ? currentCategory.algolia : "";
            setRefinedMenu([
                level1,
                level2,
                level3
            ]);
        }
    }, [
        currentCategory
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
        className: classnames_default()("navbar h-11 py-0 lg:h-10", [
            "".concat(backgroundCustom ? backgroundCustom : "bg-navbar"), 
        ]),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
            className: "navbar-nav relative mb-0 flex h-full max-w-full justify-center lg:justify-start xl:px-8",
            children: [
                menuCategories && menuCategories.length && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: isMobile || isPOS ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AislesMenuMobile_AislesMenuMobile, {
                        aislesCategories: menuCategories,
                        currentCategory: currentCategory,
                        searchUrl: searchUrl,
                        refinedMenu: refinedMenu,
                        setRefinedMenu: setRefinedMenu,
                        isMobile: isMobile,
                        isPOS: isPOS,
                        navBarHeight: navBarHeight
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItem, {
                        name: "Pasillos",
                        className: "w-full lg:w-[216px]",
                        label: "pasillo-todos-link",
                        onClick: function() {
                            return setOpenMenu(!openMenu);
                        },
                        onMouseEnter: handleHoverMenu,
                        onMouseLeave: handleLeaveMenu,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: openMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)(AislesMenu_AislesMenu, {
                                aislesCategories: aislesMenu,
                                onCloseMenu: function() {
                                    return setOpenMenu(!openMenu);
                                }
                            })
                        })
                    })
                }),
                !isPOS && mainMenu.map(function(item, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItem, {
                        name: item.name,
                        label: "pasillo-" + i,
                        icon: item.icon,
                        href: item.link,
                        className: "hidden px-5 lg:block"
                    }, "pasillo-" + i);
                })
            ]
        })
    });
};
CategoryMenu.displayName = "CategoryMenu";
NavItem.displayName = "NavItem";
CategoryMenu.defaultProps = {};
CategoryMenu.propTypes = {
    currentCategory: (prop_types_default()).object,
    menuCategories: (prop_types_default()).array,
    searchUrl: (prop_types_default()).string
};
/* harmony default export */ var CategoryMenu_CategoryMenu = (CategoryMenu);

;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/molecules/CategoryMenu/index.js


// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/atoms/Image/Image.jsx
var Image_Image = __webpack_require__(66483);
// EXTERNAL MODULE: ../../packages/designkit/src/assets/icon-camera.svg
var icon_camera = __webpack_require__(43987);
var icon_camera_default = /*#__PURE__*/__webpack_require__.n(icon_camera);
// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/atoms/Product/ProductPriceForQuantity.jsx
var ProductPriceForQuantity = __webpack_require__(29832);
// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/organisms/FullModal/index.js
var FullModal = __webpack_require__(84521);
;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/molecules/SearchedHits/SearchedHits.jsx










var CategoryLink = function(param) {
    var searchValue = param.searchValue, category = param.category, text = param.text, _underline = param.underline, underline = _underline === void 0 ? false : _underline;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link["default"], {
        underline: underline,
        href: "/c/".concat((0,src/* slugify */.lV)(category), "?q=").concat(searchValue),
        className: "font-heading text-small",
        children: text
    }, "category-link-".concat(category, "-").concat(text === "Ver todos" ? "todos" : "category"));
};
var LiProduct = /*#__PURE__*/ react.memo(function(param) {
    var product = param.product, productName = param.productName, setSearchValue = param.setSearchValue, setShowSearchResults = param.setShowSearchResults, onClickOnProduct = param.onClickOnProduct, onResultClick = param.onResultClick, context = param.context;
    var withImage = product.thumbnail && product.thumbnail.length > 0;
    var LiContent = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex w-full max-w-none items-center justify-start md:max-w-xs",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mr-3 flex items-center bg-ui-white",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_Image/* default */.Z, {
                        layout: "fixed",
                        width: 50,
                        height: 50,
                        src: withImage ? product.thumbnail : (icon_camera_default()),
                        alt: withImage ? product.name : "Producto en sesi\xf3n de fotos",
                        objectFit: withImage ? "cover" : "contain",
                        objectPosition: "center"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex h-[50px] w-full flex-col justify-between p-0 ",
                    children: [
                        context !== "pos" ? "" : context && (0,src/* get_ */.jR)(product, [
                            "stock"
                        ]) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "text-caption",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-ui-gray-500",
                                    children: "Stock: "
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "font-body-bold",
                                    children: [
                                        product.stock,
                                        product.availableStockUnit || "pz"
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-caption",
                            children: "No hay stock"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-sm leading-4",
                            dangerouslySetInnerHTML: {
                                __html: productName
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPriceForQuantity/* default */.Z, {
                                wrapperClassName: "!flex-row !items-start !justify-start gap-x-3",
                                context: "hit",
                                product: product,
                                hideDiscounts: true
                            })
                        })
                    ]
                })
            ]
        });
    };
    if (onResultClick && !(0,src/* get_ */.jR)(product, [
        "availability",
        "itemsAvailable"
    ])) return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        className: "p-2 opacity-40",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link["default"], {
            underline: false,
            style: {
                cursor: "not-allowed"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LiContent, {})
        })
    }, "product-search-".concat(product.sku));
    if (onResultClick) return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        className: "my-1 p-2 transition duration-300 ease-in-out hover:scale-95 hover:bg-brand-primary-300",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link["default"], {
            underline: false,
            onClick: function() {
                if (onClickOnProduct && typeof onClickOnProduct === "function") onClickOnProduct(product);
                onResultClick(product);
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LiContent, {})
        })
    }, "product-search-".concat(product.sku));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        className: "my-1 p-2 transition duration-300 ease-in-out hover:scale-95 hover:bg-brand-primary-300",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link["default"], {
            href: product.href,
            underline: false,
            onClick: function() {
                if (onClickOnProduct && typeof onClickOnProduct === "function") onClickOnProduct(product);
                if (setSearchValue) setSearchValue("");
                setShowSearchResults(false);
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LiContent, {})
        })
    }, "product-search-".concat(product.sku));
});
LiProduct.displayName = "LiProduct";
var highlight = function(needle, haystack) {
    return haystack.replace(new RegExp(needle, "gi"), function(str) {
        return "<strong>".concat(str, "</strong>");
    });
};
var SearchHeader = function(param) {
    var searchValue = param.searchValue, searchUrl = param.searchUrl, setSearchValue = param.setSearchValue, onClickSearch = param.onClickSearch, setShowMobileSearchModal = param.setShowMobileSearchModal;
    var handleKeyDown = function() {
        setShowMobileSearchModal(false);
        onClickSearch("".concat(searchUrl, "?q=").concat(searchValue));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative w-full border-b border-ui-black pt-0 pb-1",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchIcon/* default */.Z, {
                className: "absolute left-0 top-1/2 flex w-6 -translate-y-1/2 transform"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                type: "text",
                className: "w-full border-0 bg-ui-white pt-2 pb-1 pl-8 pr-2 text-normal focus:border-ui-black focus:ring-0",
                value: searchValue,
                placeholder: "Busca los mejores productos",
                onChange: function(event) {
                    return setSearchValue(event.target.value);
                },
                id: "mobilesearchinput",
                autoFocus: true,
                onKeyDown: function(keyDown) {
                    return keyDown.key === "Enter" && onClickSearch ? handleKeyDown() : "";
                },
                autoComplete: "off",
                autoCorrect: "off",
                autoCapitalize: "off",
                spellCheck: "false"
            })
        ]
    });
};
var SearchedHitsComponent = function(param) {
    var searchValue = param.searchValue, searchResults = param.searchResults, setSearchValue = param.setSearchValue, setShowSearchResults = param.setShowSearchResults, onClickOnProduct = param.onClickOnProduct, onResultClick = param.onResultClick, context = param.context;
    var extractHits = function(hits, nBHits) {
        return hits.slice(0, nBHits).map(function(product, index) {
            var productName = product.name.length > 30 ? product.name.substring(0, 30) + "..." : product.name;
            productName = highlight(searchValue, productName);
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(LiProduct, {
                product: product,
                productName: productName,
                setSearchValue: setSearchValue,
                setShowSearchResults: setShowSearchResults,
                onClickOnProduct: onClickOnProduct,
                onResultClick: onResultClick,
                context: context
            }, index);
        });
    };
    var nbHits = Object.keys(searchResults).length > 1 ? 4 : 8;
    return Object.keys(searchResults).map(function(category) {
        var objects = extractHits(searchResults[category], nbHits);
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "col-span-1 w-full px-3",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                    className: "mx-2 mt-0 mb-5 border-b border-black md:mb-1",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryLink, {
                        searchValue: searchValue,
                        category: category,
                        text: category
                    })
                }),
                Object.keys(searchResults).length > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: "md:flex-1",
                    children: objects
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "my-2 md:mb-0 md:flex",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    className: "mb-2 md:flex-1",
                                    children: objects.length > 4 ? objects.slice(0, 4) : objects
                                }),
                                objects.length > 4 && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    className: "mb-2 md:flex-1",
                                    children: objects.slice(4, objects.length)
                                })
                            ]
                        }),
                        category !== "Otras categor\xedas" && /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryLink, {
                            searchValue: searchValue,
                            category: category,
                            text: "Ver todos",
                            underline: true
                        })
                    ]
                })
            ]
        }, "search-category-column-c-".concat(category));
    });
};
function SearchedHits(param) {
    var searchValue = param.searchValue, setSearchValue = param.setSearchValue, searchResults = param.searchResults, setShowSearchResults = param.setShowSearchResults, onClickOnProduct = param.onClickOnProduct, onResultClick = param.onResultClick, context = param.context, showMobileSearchModal = param.showMobileSearchModal, setShowMobileSearchModal = param.setShowMobileSearchModal, onClickSearch = param.onClickSearch, searchUrl = param.searchUrl, isInModal = param.isInModal;
    if (isInModal) return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FullModal["default"], {
        onClose: function() {
            return setShowMobileSearchModal(false);
        },
        isOpen: showMobileSearchModal,
        overlayClassName: !searchValue && searchValue.length === 0 ? "bg-overlay-gray-100" : "bg-ui-gray-100",
        headerBackgroundColor: "bg-ui-white",
        headerShadow: true,
        headerContent: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchHeader, {
            searchValue: searchValue,
            searchUrl: searchUrl,
            setSearchValue: setSearchValue,
            onClickSearch: onClickSearch,
            setShowMobileSearchModal: setShowMobileSearchModal
        }),
        children: [
            !searchValue && searchValue.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-10 flex flex-col items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "mb-3 flex h-11 w-11 items-center justify-center rounded-full border border-ui-gray-500",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchIcon/* default */.Z, {
                            className: "block w-7 text-ui-gray-500"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "text-center font-body text-normal font-body-regular leading-snug text-ui-gray-500",
                        children: [
                            "Busca los mejores productos ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "en YEMA"
                        ]
                    })
                ]
            }),
            searchValue && searchValue.length > 0 && searchResults && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: Object.keys(searchResults).length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchedHitsComponent, {
                    searchValue: searchValue,
                    searchResults: searchResults,
                    setSearchValue: setSearchValue,
                    setShowSearchResults: setShowMobileSearchModal,
                    onClickOnProduct: onClickOnProduct,
                    onResultClick: onResultClick,
                    setShowMobileSearchModal: setShowMobileSearchModal
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "px-5",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "font-body text-normal font-body-regular text-ui-black",
                        children: "No se encontraron productos con esos criterios"
                    })
                })
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchedHitsComponent, {
        searchValue: searchValue,
        searchResults: searchResults,
        setSearchValue: setSearchValue,
        setShowSearchResults: setShowSearchResults,
        onClickOnProduct: onClickOnProduct,
        onResultClick: onResultClick,
        context: context
    });
};
SearchedHits.defaultProps = {
    searchValue: "",
    searchResults: {},
    setSearchValue: function() {},
    setShowSearchResults: function() {},
    context: "",
    isInModal: false
};
SearchedHits.propTypes = {
    searchValue: prop_types.string,
    searchResults: prop_types.object,
    setSearchValue: prop_types.func,
    setShowSearchResults: prop_types.func,
    onClickOnProduct: prop_types.func,
    onResultClick: prop_types.func,
    context: prop_types.string
};

;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/molecules/SearchedHits/index.js


;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/atoms/HeaderItem/HeaderItem.jsx





var HeaderItem = function(param) {
    var className = param.className, label = param.label, mobileLabel = param.mobileLabel, href = param.href, prefetch = param.prefetch, onClick = param.onClick, icon = param.icon, withBadge = param.withBadge, badgePosition = param.badgePosition, counter = param.counter, withBorder = param.withBorder;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()("flex h-full items-center justify-center", className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link["default"], {
                className: classnames_default()("flex h-full w-full flex-col items-center px-1 text-xxs xxs:text-caption md:px-2 xl:text-small"),
                underline: false,
                href: href,
                label: label,
                onClick: onClick,
                prefetch: prefetch,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex items-center justify-center text-ui-black",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "relative w-6 xl:w-6",
                                children: [
                                    icon,
                                    (withBadge || counter !== null && counter > 0) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        id: "shopping-bag-items-counter",
                                        className: "absolute mr-2 flex items-center justify-center rounded-xl bg-brand-primary-700 text-ui-white",
                                        style: {
                                            width: !counter ? "12px" : counter > 99 ? "18px" : "16px",
                                            height: !counter ? "12px" : counter > 99 ? "18px" : "16px",
                                            right: badgePosition && badgePosition.right,
                                            top: badgePosition && badgePosition.top,
                                            fontSize: counter > 99 ? "8px" : "9px",
                                            lineHeight: "10px"
                                        },
                                        children: counter > 99 ? "99+" : counter
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "hidden text-right lg:block",
                            children: label
                        }),
                        mobileLabel && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "relative block text-center lg:hidden",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "border-ui-black text-right",
                                children: mobileLabel
                            })
                        })
                    ]
                })
            }),
            withBorder && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "hidden h-8 w-px bg-ui-gray-500 md:block"
            })
        ]
    });
};
HeaderItem.propTypes = {
    className: prop_types.string,
    label: prop_types.string,
    mobileLabel: prop_types.string,
    href: prop_types.string,
    onClick: prop_types.func,
    icon: prop_types.node.isRequired,
    withBadge: prop_types.bool,
    badgePosition: prop_types.object,
    counter: prop_types.number,
    withBorder: prop_types.bool
};
HeaderItem.defaultProps = {
    withBadge: false
};
/* harmony default export */ var HeaderItem_HeaderItem = (HeaderItem);

;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/atoms/HeaderItem/index.js


// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/molecules/PromoHeader/PromoHeader.module.scss
var PromoHeader_module = __webpack_require__(96053);
var PromoHeader_module_default = /*#__PURE__*/__webpack_require__.n(PromoHeader_module);
;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/molecules/PromoHeader/PromoHeader.jsx









var PromoHeader = /*#__PURE__*/ react.forwardRef(function(param, ref) {
    var promoInfo = param.promoInfo, onClose = param.onClose;
    var isMobile = (0,lib/* default */.ZP)({
        maxWidth: 640
    });
    var _$ref = promoInfo || {}, icon = _$ref.icon, text = _$ref.text, background_color = _$ref.background_color, text_color = _$ref.text_color, link = _$ref.link, published = _$ref.published;
    var containerClass = classnames_default()("relative w-full");
    var textClass = classnames_default()("w-full flex justify-center py-3", {
        "cursor-pointer": link && link.link,
        "items-center": !isMobile,
        "pl-6 pr-10 items-start": isMobile
    });
    if (!published) return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            height: "42px"
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "promoheader",
        ref: ref,
        className: containerClass,
        style: {
            zIndex: 9999999,
            backgroundColor: background_color,
            color: text_color
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()(textClass, "gap-x-1 sm:gap-x-3"),
                onClick: link.link ? src/* links.handleRedirect */.Ok.handleRedirect(link.link) : null,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        layout: "fixed",
                        width: 18,
                        height: 18,
                        src: icon,
                        alt: "check"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "m-0 text-center font-body text-small font-body-bold ".concat((PromoHeader_module_default()).text),
                        dangerouslySetInnerHTML: {
                            __html: text
                        }
                    })
                ]
            }),
            onClose && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()("absolute top-0 right-0 mt-2 mb-px mr-5 cursor-pointer", {
                    "mr-3": isMobile
                }),
                onClick: onClose,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon/* default */.Z, {
                    className: "h-5 w-5"
                })
            })
        ]
    });
});
PromoHeader.propTypes = {
    promoInfo: prop_types.shape({
        background_color: prop_types.string,
        icon: prop_types.string,
        published: prop_types.bool,
        text: prop_types.string,
        text_color: prop_types.string
    }),
    onClose: prop_types.func
};
/* harmony default export */ var PromoHeader_PromoHeader = (PromoHeader);

;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/molecules/PromoHeader/index.js


// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/molecules/Tooltip/index.js
var Tooltip = __webpack_require__(63129);
;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/organisms/Header/Header.jsx
/* provided dependency */ var process = __webpack_require__(34406);














var HeaderMenu = function(param) {
    var setShowMobileSearchModal = param.setShowMobileSearchModal, onChangeDeliveryLocation = param.onChangeDeliveryLocation, deliveryPostalCode = param.deliveryPostalCode, userLoggedIn = param.userLoggedIn, username = param.username, cartCount = param.cartCount, cartTotal = param.cartTotal;
    var splitUsername = username.split(" ");
    var parsedUsername = splitUsername.length > 1 ? splitUsername[0] : username;
    var ref = (0,react.useState)(false), showCartTooltip = ref[0], setShowCartTooltip = ref[1];
    (0,react.useEffect)(function() {
        if (src/* sessionstorage.get */.zN.get("y_synced_cart_alert")) {
            setShowCartTooltip(true);
        }
    }, [
        src/* sessionstorage.get */.zN.get("y_synced_cart_alert")
    ]);
    var isStorefront3B = process.env.NEXT_PUBLIC_CONTEXT === "storefront_3b";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            onChangeDeliveryLocation && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip["default"], {
                uniqueId: "no-delivery-postal-code-alert",
                anchorClassName: "order-2 w-12 md:order-1 md:w-16 lg:w-auto",
                placement: "bottom",
                tooltipContent: deliveryPostalCode ? null : "Est\xe1s viendo todo nuestro cat\xe1logo, algunos productos dependen " + "de la direcci\xf3n de entrega. Selecciona tu c\xf3digo postal para ver los " + "productos disponibles en tu zona.",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderItem_HeaderItem, {
                    label: "".concat(deliveryPostalCode ? "Entrega a: ".concat(deliveryPostalCode) : "Direcci\xf3n no especificada"),
                    mobileLabel: deliveryPostalCode ? "".concat(deliveryPostalCode) : "Sin CP",
                    onClick: onChangeDeliveryLocation,
                    icon: deliveryPostalCode ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationHomeIcon/* default */.Z, {
                        className: "h-6 w-6"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationUnknownIcon/* default */.Z, {
                        className: "h-6 w-6"
                    }),
                    withBadge: !deliveryPostalCode,
                    badgePosition: {
                        right: "-8px",
                        top: "-2px"
                    },
                    withBorder: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderItem_HeaderItem, {
                className: "order-4 w-12 md:hidden md:w-16 lg:w-auto",
                label: "Buscar",
                onClick: function() {
                    return setShowMobileSearchModal(true);
                },
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchIcon/* default */.Z, {}),
                mobileLabel: "Buscar"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link["default"], {
                underline: false,
                href: "/",
                label: "Home",
                className: "order-3 md:hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LogosBrand/* default */.Z, {
                    type: isStorefront3B ? "simple_black" : "horizontal_black",
                    className: classnames_default()("block w-full xxs:w-32 sm:w-36", isStorefront3B && "h-12")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderItem_HeaderItem, {
                className: "order-1 w-12 md:order-2 md:w-16 lg:w-auto",
                withBorder: true,
                label: userLoggedIn ? username && username !== "" ? "\xa1Hola, ".concat(parsedUsername, "!") : "Mi cuenta" : "Cuenta",
                mobileLabel: userLoggedIn ? username && username !== "" ? parsedUsername : "Hola" : "Cuenta",
                href: userLoggedIn ? "/cuenta" : "/cuenta/login",
                prefetch: false,
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserIcon/* default */.Z, {
                    className: "h-6 w-6"
                })
            }),
            showCartTooltip ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip["default"], {
                uniqueId: "synced-cart",
                anchorClassName: "order-5",
                tooltipBgColor: "bg-brand-tertiary-500",
                arrowFillColor: "fill-brand-tertiary-500",
                placement: "bottom",
                showOnHover: false,
                tooltipContent: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "mb-1 flex items-center justify-between gap-x-2 font-body-bold",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-center gap-x-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CartIcon/* default */.Z, {
                                            className: "h-6 w-6"
                                        }),
                                        "Ten\xedas productos en otro carrito"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: "hover:scale-105",
                                    type: "button",
                                    onClick: function() {
                                        setShowCartTooltip(false);
                                        src/* sessionstorage.remove */.zN.remove("y_synced_cart_alert");
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon/* default */.Z, {
                                        className: "h-5 w-5"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mb-0",
                            children: "Tienes abierta tu sesi\xf3n en otro sitio con productos en tu carrito. No te preocupes, los agregamos a este."
                        })
                    ]
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderItem_HeaderItem, {
                    href: "/carrito",
                    prefetch: false,
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CartIcon/* default */.Z, {
                        className: "h-6 w-6"
                    }),
                    counter: cartCount,
                    label: cartTotal !== null ? src/* money.formatMoney */.CZ.formatMoney(cartTotal) : "Mi carrito",
                    mobileLabel: cartTotal !== null ? src/* money.formatMoney */.CZ.formatMoney(cartTotal) : "Carrito",
                    badgePosition: {
                        right: "-14px",
                        top: "-8px"
                    }
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderItem_HeaderItem, {
                className: "order-5",
                href: "/carrito",
                prefetch: false,
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CartIcon/* default */.Z, {
                    className: "h-6 w-6"
                }),
                counter: cartCount,
                label: cartTotal !== null ? src/* money.formatMoney */.CZ.formatMoney(cartTotal) : "Mi carrito",
                mobileLabel: cartTotal !== null ? src/* money.formatMoney */.CZ.formatMoney(cartTotal) : "Carrito",
                badgePosition: {
                    right: "-14px",
                    top: "-8px"
                }
            })
        ]
    });
};
var Header = function(param) {
    var fullHeader = param.fullHeader, userLoggedIn = param.userLoggedIn, username = param.username, cartCount = param.cartCount, cartTotal = param.cartTotal, submenu = param.submenu, currentCategory = param.currentCategory, catalogSettings = param.catalogSettings, onChangeDeliveryLocation = param.onChangeDeliveryLocation, onClickSearch = param.onClickSearch, refineResults = param.refineResults, searchResults = param.searchResults, isMobile = param.isMobile, promoHeader = param.promoHeader, onClickOnProduct = param.onClickOnProduct;
    var ref = (0,react.useState)(""), searchValue = ref[0], setSearchValue = ref[1];
    var ref1 = (0,react.useState)(false), showMobileSearchModal = ref1[0], setShowMobileSearchModal = ref1[1];
    var ref2 = (0,react.useState)(false), showSearchResults = ref2[0], setShowSearchResults = ref2[1];
    var ref3 = (0,react.useState)(0), navBarHeight = ref3[0], setNaviBarHeight = ref3[1];
    var navRef = (0,react.useRef)(null);
    var searchUrl = "/s";
    (0,react.useEffect)(function() {
        if (promoHeader) {
            setNaviBarHeight(navRef.current.clientHeight);
        }
    }, [
        promoHeader
    ]);
    var handleGoSearch = function(searchedValue) {
        setSearchValue("");
        setShowSearchResults(false);
        onClickSearch("".concat(searchUrl, "?q=").concat(searchedValue));
    };
    (0,react.useEffect)(function() {
        if (refineResults) {
            var refineWithTimer = setTimeout(function() {
                refineResults(searchValue);
            }, 600);
            return function() {
                clearTimeout(refineWithTimer);
            };
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        searchValue
    ]);
    (0,react.useEffect)(function() {
        if (!isMobile && searchValue && searchValue.length > 0 && searchResults && Object.keys(searchResults).length > 0) {
            setShowSearchResults(true);
        }
    }, [
        searchValue,
        isMobile,
        searchResults
    ]);
    (0,react.useEffect)(function() {
        var handleScroll = function() {
            return setShowSearchResults(false);
        };
        if (true) {
            window.addEventListener("scroll", handleScroll);
        // window.addEventListener('load', handleInitHeaderHeight);
        }
        return function() {
            if (true) {
                window.removeEventListener("scroll", handleScroll);
            // window.removeEventListener('load', handleInitHeaderHeight);
            }
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: fullHeader ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchedHits, {
                    isInModal: true,
                    showMobileSearchModal: showMobileSearchModal,
                    setShowMobileSearchModal: setShowMobileSearchModal,
                    searchValue: searchValue,
                    setSearchValue: setSearchValue,
                    onClickSearch: function() {
                        return handleGoSearch(searchValue);
                    },
                    searchUrl: searchUrl,
                    searchResults: searchResults,
                    onClickOnProduct: onClickOnProduct
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "sticky top-0 left-0 z-[1000] w-full bg-ui-white shadow-md",
                    ref: navRef,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PromoHeader_PromoHeader, {
                            promoInfo: promoHeader
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                            id: "header",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "relative h-15 pt-3 pb-2 md:h-auto md:px-6 md:pt-2 lg:px-8",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex w-full items-center justify-between",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link["default"], {
                                                underline: false,
                                                href: "/",
                                                label: "Home",
                                                className: "hidden md:block",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LogosBrand/* default */.Z, {
                                                    type: "horizontal_black",
                                                    className: "block w-48 lg:w-56"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "hidden w-2/5 md:block",
                                                children: catalogSettings && catalogSettings.index && /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchInput_SearchInput, {
                                                    inputKey: "catalog-autocomplete-search-bar",
                                                    onChange: function(value) {
                                                        return setSearchValue(value);
                                                    },
                                                    onClick: function() {
                                                        return handleGoSearch(searchValue);
                                                    },
                                                    value: searchValue,
                                                    placeholder: "Busca los mejores productos",
                                                    withIcon: true,
                                                    autocomplete: "off",
                                                    onKeyDown: function(event) {
                                                        // keyCode 27 = 'ESC' key
                                                        if (event.keyCode === 27) {
                                                            event.preventDefault();
                                                            setShowSearchResults(false);
                                                        }
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex w-full items-center justify-between md:w-auto",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMenu, {
                                                    setShowMobileSearchModal: setShowMobileSearchModal,
                                                    onChangeDeliveryLocation: onChangeDeliveryLocation,
                                                    deliveryPostalCode: catalogSettings ? catalogSettings.zipCode : null,
                                                    userLoggedIn: userLoggedIn,
                                                    username: username,
                                                    cartCount: cartCount,
                                                    cartTotal: cartTotal
                                                })
                                            })
                                        ]
                                    }),
                                    !isMobile && showSearchResults && Object.keys(searchResults).length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        // eslint-disable-next-line react/no-unknown-property
                                        before: "",
                                        className: "absolute left-0 z-100 h-[385px] w-full bg-brand-tertiary-100 py-5 before:absolute before:left-[calc(71.3%_-_50px)] before:top-[-8px] before:h-[14px] before:w-[14px] before:rotate-45 before:transform before:border-t before:border-l before:border-ui-black before:bg-brand-tertiary-100 before:content-[attr(before)] md:top-[72px] lg:top-[81px] before:lg:left-[calc(69.6%_-_50px)]",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "lg:container",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "flex",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchedHits, {
                                                        searchValue: searchValue,
                                                        searchResults: searchResults,
                                                        setSearchValue: setSearchValue,
                                                        setShowSearchResults: setShowSearchResults,
                                                        onClickOnProduct: onClickOnProduct
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon/* default */.Z, {
                                                className: "absolute top-3.5 right-3.5 h-5 w-5 cursor-pointer hover:scale-110",
                                                onClick: function() {
                                                    setSearchValue("");
                                                    setShowSearchResults(false);
                                                }
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        submenu && submenu.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryMenu_CategoryMenu, {
                            currentCategory: currentCategory,
                            menuCategories: submenu,
                            searchUrl: searchUrl,
                            navBarHeight: navBarHeight
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "sticky top-0 left-0 z-[1000] w-full bg-ui-white shadow-md",
                ref: navRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                    className: "relative",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative flex h-15 w-full items-center justify-center px-2 pt-3 pb-2 md:h-16 md:px-6 md:pt-2 lg:px-8",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link["default"], {
                            underline: false,
                            href: "/",
                            label: "Home",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LogosBrand/* default */.Z, {
                                type: "horizontal_black",
                                className: "block w-24 xxs:w-32 sm:w-36 md:w-40"
                            })
                        })
                    })
                })
            })
        })
    });
};
Header.displayName = "Header";
Header.defaultProps = {
    fullHeader: false,
    userLoggedIn: false,
    cartCount: 0,
    cartTotal: null,
    submenu: [],
    currentCategory: {}
};
Header.propTypes = {
    fullHeader: prop_types.bool.isRequired,
    userLoggedIn: prop_types.bool,
    username: prop_types.string,
    cartCount: prop_types.number,
    cartTotal: prop_types.number,
    submenu: prop_types.array,
    currentCategory: prop_types.object,
    catalogSettings: prop_types.object,
    onChangeDeliveryLocation: prop_types.func
};
/* harmony default export */ var Header_Header = (/*#__PURE__*/react.memo(Header));

;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/organisms/Header/index.js



/***/ }),

/***/ 96053:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"text":"PromoHeader_text__cixx_"};

/***/ }),

/***/ 43987:
/***/ (function(module) {

module.exports = "/_next/static/images/icon-camera-5d664641812d0cecbead936b8866b0c0.svg";

/***/ }),

/***/ 62877:
/***/ (function(module) {

module.exports = "/_next/static/images/trolley-66460abd2cd7d133acd7e60ff960a97e.png";

/***/ }),

/***/ 14830:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

function ArrowRightIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M11.43 21a.38.38 0 01-.287-.132.398.398 0 01.035-.553l8.815-7.924H3.383A.387.387 0 013 12c0-.216.172-.391.383-.391h16.608l-8.814-7.924A.394.394 0 0111.43 3c.094 0 .183.034.253.098l8.925 8.022a1.165 1.165 0 01.382.804.291.291 0 01.005.127v.022c-.02.314-.158.6-.387.808l-8.924 8.022a.379.379 0 01-.253.097z"
  }));
}
const ForwardRef = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(ArrowRightIcon);
/* harmony default export */ __webpack_exports__["Z"] = (ForwardRef);

/***/ }),

/***/ 55644:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

function CartIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M20.925 6.4c-.075-.075-.15-.15-.3-.15H6.375L6 4.3c0-.15-.225-.3-.375-.3h-2.25C3.15 4 3 4.15 3 4.375s.15.375.375.375h1.95l1.8 9.15c.225 1.2 1.35 2.1 2.55 2.1H18.3c.225 0 .375-.15.375-.375s-.15-.375-.375-.375H9.75c-.6 0-1.2-.3-1.5-.825l10.95-1.5c.15 0 .3-.15.3-.3l1.5-6s0-.15-.075-.225zm-2.1 5.85l-10.95 1.425-1.35-6.75H20.1l-1.275 5.325zM9.375 16.75c-1.05 0-1.875.825-1.875 1.875S8.325 20.5 9.375 20.5s1.875-.825 1.875-1.875-.825-1.875-1.875-1.875zm0 3c-.6 0-1.125-.525-1.125-1.125S8.775 17.5 9.375 17.5s1.125.525 1.125 1.125-.525 1.125-1.125 1.125zM16.875 16.75c-1.05 0-1.875.825-1.875 1.875s.825 1.875 1.875 1.875 1.875-.825 1.875-1.875-.825-1.875-1.875-1.875zm0 3c-.6 0-1.125-.525-1.125-1.125s.525-1.125 1.125-1.125S18 18.025 18 18.625s-.525 1.125-1.125 1.125z"
  }));
}
const ForwardRef = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(CartIcon);
/* harmony default export */ __webpack_exports__["Z"] = (ForwardRef);

/***/ }),

/***/ 13398:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

function ChevronDownIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M11.999 17a.895.895 0 01-.624-.244l-9.27-9.151a.332.332 0 01.036-.513A.453.453 0 012.416 7c.12 0 .234.045.313.123l9.27 9.15 9.272-9.15A.446.446 0 0121.584 7c.101 0 .2.033.275.091a.333.333 0 01.036.514l-9.271 9.15a.912.912 0 01-.625.244z"
  }));
}
const ForwardRef = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(ChevronDownIcon);
/* harmony default export */ __webpack_exports__["Z"] = (ForwardRef);

/***/ }),

/***/ 12073:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

function ChevronRightIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M7.364 22a.345.345 0 01-.272-.14.46.46 0 01.03-.588L16.274 12l-9.15-9.27a.461.461 0 01-.032-.59c.07-.088.169-.14.273-.14a.34.34 0 01.24.104l9.152 9.272c.021.022.04.043.059.067.268.346.241.875-.058 1.18l-9.152 9.273a.338.338 0 01-.241.104z"
  }));
}
const ForwardRef = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(ChevronRightIcon);
/* harmony default export */ __webpack_exports__["Z"] = (ForwardRef);

/***/ }),

/***/ 83150:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

function LocationHomeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M19.5 10.101c-.02 2.535-.902 4.6-2.883 5.94-1.525 1.03-2.522 2.366-3.346 3.931-.233.441-.374 1.047-1.057 1.028-.632-.02-.738-.61-.994-1.018-.257-.408-.51-.868-.746-1.31a6 6 0 00-2.07-2.232c-2.52-1.646-3.665-4.015-3.354-6.989.453-4.321 4.539-7.162 8.584-6.295 3.095.662 4.992 2.624 5.72 5.705.077.41.125.824.146 1.24zm-7.254 10.13c.415-.727.771-1.323 1.103-1.939.575-1.059 1.389-1.873 2.396-2.543 2.14-1.425 3.17-3.45 2.939-6.034-.238-2.667-1.662-4.539-4.123-5.497-2.462-.959-4.803-.498-6.735 1.324-3.101 2.912-2.688 7.743.838 10.14a7.896 7.896 0 012.657 2.912c.267.516.572 1.015.925 1.638z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M9.518 13c-.168 0-.304-.122-.304-.271V9.417l-.714.54a.329.329 0 01-.428-.033.251.251 0 01.035-.381l3.947-2.98a.326.326 0 01.196-.063c.072 0 .141.022.196.064l3.946 2.979a.252.252 0 01.036.382.32.32 0 01-.232.096.326.326 0 01-.195-.064l-.715-.54v3.312c0 .15-.136.27-.303.27H9.518zm5.161-.542v-3.5L12.25 7.125 9.822 8.958v3.5h1.214v-1.355c0-.597.545-1.083 1.214-1.083.67 0 1.215.486 1.215 1.083v1.355h1.214zm-1.822 0v-1.355c0-.299-.271-.542-.607-.542-.335 0-.607.243-.607.542v1.354h1.214z"
  }));
}
const ForwardRef = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(LocationHomeIcon);
/* harmony default export */ __webpack_exports__["Z"] = (ForwardRef);

/***/ }),

/***/ 13424:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

function LocationUnknownIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M12 14c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4zm0-7.385A3.388 3.388 0 008.615 10 3.388 3.388 0 0012 13.385 3.388 3.388 0 0015.385 10 3.388 3.388 0 0012 6.615z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M12 11.18a.308.308 0 01-.308-.309v-.615c0-.17.138-.308.308-.308a.847.847 0 000-1.692.847.847 0 00-.846.846.308.308 0 01-.615 0c0-.806.655-1.461 1.461-1.461a1.463 1.463 0 01.308 2.89v.34c0 .17-.138.308-.308.308zM12 12.717a.462.462 0 100-.923.462.462 0 000 .923z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M19.5 10.101c-.02 2.535-.902 4.6-2.883 5.94-1.525 1.03-2.522 2.366-3.346 3.931-.233.441-.374 1.047-1.057 1.028-.632-.02-.738-.61-.994-1.018-.257-.408-.51-.868-.746-1.31a6 6 0 00-2.07-2.232c-2.52-1.646-3.665-4.015-3.354-6.989.453-4.321 4.539-7.162 8.584-6.295 3.095.662 4.992 2.624 5.72 5.705.077.41.125.824.146 1.24zm-7.254 10.13c.415-.727.771-1.323 1.103-1.939.575-1.059 1.389-1.873 2.396-2.543 2.14-1.425 3.17-3.45 2.939-6.034-.238-2.667-1.662-4.539-4.123-5.497-2.462-.959-4.803-.498-6.735 1.324-3.101 2.912-2.688 7.743.838 10.14a7.896 7.896 0 012.657 2.912c.267.516.572 1.015.925 1.638z"
  }));
}
const ForwardRef = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(LocationUnknownIcon);
/* harmony default export */ __webpack_exports__["Z"] = (ForwardRef);

/***/ }),

/***/ 67566:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

function SearchIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M20.625 21a.374.374 0 01-.265-.11L16.168 16.7a7.832 7.832 0 01-5.293 2.051C6.532 18.75 3 15.217 3 10.875 3 6.532 6.532 3 10.875 3c4.342 0 7.875 3.532 7.875 7.875a7.83 7.83 0 01-2.052 5.293l4.192 4.192a.374.374 0 01-.265.64zm-9.75-17.25c-3.928 0-7.125 3.197-7.125 7.125S6.947 18 10.875 18 18 14.803 18 10.875 14.803 3.75 10.875 3.75z"
  }));
}
const ForwardRef = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(SearchIcon);
/* harmony default export */ __webpack_exports__["Z"] = (ForwardRef);

/***/ }),

/***/ 32586:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

function UserIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M11.6 12.6a4.806 4.806 0 01-4.8-4.8C6.8 5.154 8.954 3 11.6 3s4.8 2.154 4.8 4.8-2.154 4.8-4.8 4.8zm0-8.8c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4zM4.4 21a.4.4 0 01-.4-.4c0-4.19 3.41-7.6 7.6-7.6 4.19 0 7.6 3.41 7.6 7.6a.4.4 0 01-.4.4H4.4zm13.989-.8c-.209-3.548-3.212-6.4-6.789-6.4-3.577 0-6.58 2.852-6.788 6.4h13.577z"
  }));
}
const ForwardRef = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(UserIcon);
/* harmony default export */ __webpack_exports__["Z"] = (ForwardRef);

/***/ })

}]);